import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { TextField, Button } from '@mui/material';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.send(
      'service_ajzat3d',    // Replace with your Service ID from EmailJS
      'template_jy9rmwt',    // Replace with your Template ID from EmailJS
      formData,
      'InSa6dvS4aREWlHKb'         // Replace with your User ID from EmailJS
    )
    .then((result) => {
      alert('Message sent successfully!');
    }, (error) => {
      alert('An error occurred, please try again.');
      console.log(error.text);
    });
  };

  return (
    <form onSubmit={handleSubmit} className="bg-black/50 shadow-lg rounded-lg p-8 space-y-4 max-w-xl mx-auto">
      <TextField
        label="Name"
        name="name"
        variant="outlined"
        fullWidth
        onChange={handleInputChange}
        InputProps={{ style: { backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#ffffff' } }}
        InputLabelProps={{ style: { color: '#ffffff' } }}
      />
      <TextField
        label="Email"
        name="email"
        variant="outlined"
        fullWidth
        onChange={handleInputChange}
        InputProps={{ style: { backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#ffffff' } }}
        InputLabelProps={{ style: { color: '#ffffff' } }}
      />
      <TextField
        label="Message"
        name="message"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        onChange={handleInputChange}
        InputProps={{ style: { backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#ffffff' } }}
        InputLabelProps={{ style: { color: '#ffffff' } }}
      />
      <Button type="submit" variant="contained" fullWidth style={{ backgroundColor: '#FF0000', color: '#ffffff', fontWeight: 'bold' }}>
        Send Message
      </Button>
    </form>
  );
};

export default Contact;
